import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import Contact from "./contact/Contact";
import Facility from "./facility/Facility";
import Certification from "./certification/Certification";
import NotFound from "./general/NotFound";

const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
      >
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={ROUTES.CONTACT}
            element={<Contact />}
          />
          <Route
            path={ROUTES.FACILITY}
            element={<Facility />}
          />
          <Route
            path={ROUTES.CERTIFICATION}
            element={<Certification />}
          />
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
